/* eslint-disable no-console */

import { register } from 'register-service-worker';

// if (process.env.NODE_ENV === 'production') {
register(`${process.env.BASE_URL}service-worker.js`, {
	registrationOptions: { scope: '/' },
	ready() {
		console.log(
			'[Service Worker] App is being served from cache by a service worker.\n'
			+ 'For more details, visit https://goo.gl/AFskqB',
		);
	},
	registered() {
		console.log('[Service Worker] Service worker has been registered.');
	},
	cached() {
		console.log('[Service Worker] Content has been cached for offline use.');
	},
	updatefound() {
		console.log('[Service Worker] New content is downloading.');
	},
	updated() {
		console.log('[Service Worker] New content is available; please refresh.');
	},
	offline() {
		console.log('[Service Worker] No internet connection found. App is running in offline mode.');
	},
	error(error) {
		console.error('[Service Worker] Error during service worker registration:', error);
	},
});
// }
